import { render, staticRenderFns } from "./MediaTransform.vue?vue&type=template&id=047e5808&scoped=true&"
import script from "./MediaTransform.vue?vue&type=script&lang=js&"
export * from "./MediaTransform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e5808",
  null
  
)

export default component.exports